
import React, { useState, useContext } from 'react';
import { useLocation } from "react-router-dom";
import { UserContext } from '../../UserContext.js';

import styles from './UpdateDeliveryDetailsScreen.module.css';
import helpers from '../../helpers.js';

import ScreenHeader from "../ScreenHeader.js";
import Module from "../Module.js";
import Button from "../Button.js";
import TextInput from "../TextInput.js";




function UpdateDeliveryDetailsScreen(props) {
  const {user, setUser} = useContext(UserContext);
  const [errorPrompt, setErrorPrompt] = useState("");
  const [highlighedtInput, setHighlighedtInput] = useState("");
  const locationState = useLocation().state || {};
  console.log(locationState)
  const redirectToReview = locationState !== undefined && locationState.formDataCheckout !== undefined ? true : false;
  console.log(redirectToReview)
const setAddresses = locationState.setAddresses || null;
const formDataCheckout = locationState.formDataCheckout || null;
const deliveryDetails = locationState.deliveryDetails || {};
const billingDetails = locationState.billingDetails || {};

  // console.log(deliveryDetails);
  // const [formData, setFormData] = useState(deliveryDetails);
  // const [formData, setFormData] = useState({
  //   ...deliveryDetails,
  //   firstName: deliveryDetails.firstName || user?.details?.firstName || "",
  //   lastName: deliveryDetails.lastName || user?.details?.lastName || "",
  //   email: deliveryDetails.email || user?.details?.email || "",
  //   phone: deliveryDetails.phone || user?.details?.phone || "",
  //   country: deliveryDetails.country || user?.details?.country || "",
  //   businessName: deliveryDetails.businessName || user?.details?.businessName || ""
  // });
  console.log(user.details)
  console.log(deliveryDetails)
 const [formData, setFormData] = useState({
  firstName: deliveryDetails.firstName && deliveryDetails.firstName !== "" ? deliveryDetails.firstName : user?.details?.firstName ?? "",
  lastName: deliveryDetails.lastName && deliveryDetails.lastName !== "" ? deliveryDetails.lastName : user?.details?.lastName ?? "",
  phone: deliveryDetails.phone && deliveryDetails.phone !== "" ? deliveryDetails.phone : user?.details?.phoneMobile ?? "",
  email: deliveryDetails.email && deliveryDetails.email !== "" ? deliveryDetails.email : user?.details?.email ?? "",
  businessName: deliveryDetails.businessName && deliveryDetails.businessName !== "" ? deliveryDetails.businessName : user?.details?.businessName ?? "",
  addressLine1: deliveryDetails.addressLine1 && deliveryDetails.addressLine1 !== "" ? deliveryDetails.addressLine1 : "",
  addressLine2: deliveryDetails.addressLine2 ?? "",
  city: deliveryDetails.city ?? "",
  county: deliveryDetails.county ?? "",
  zip: deliveryDetails.zip ?? "",
  country: deliveryDetails.country ?? "",
  instructions: deliveryDetails.instructions ?? ""
});
  const handleChange = (formField, value) => {
    setFormData({ ...formData, [formField]: value });
  };

  const handleSubmit = async () => {
if (typeof formData.firstName === "undefined" || formData.firstName.trim() === "") {
  helpers.errorPrompt("Please enter a valid first name", "firstName", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.lastName === "undefined" || formData.lastName.trim() === "") {
  helpers.errorPrompt("Please enter a valid last name", "lastName", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.phone === "undefined" || formData.phone.trim() === "") {
  helpers.errorPrompt("Please enter a valid phone number", "phone", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.email === "undefined" || !helpers.isValidEmail(formData.email)) {
  helpers.errorPrompt("Please enter a valid email address", "email", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.addressLine1 === "undefined" || formData.addressLine1.trim() === "") {
  helpers.errorPrompt("Please enter a valid address (line 1)", "addressLine1", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.city === "undefined" || formData.city.trim() === "") {
  helpers.errorPrompt("Please enter a valid city", "city", setErrorPrompt, setHighlighedtInput);
  return;
} else if (typeof formData.zip === "undefined" || formData.zip.trim() === "") {
  helpers.errorPrompt("Please enter a valid postal code", "zip", setErrorPrompt, setHighlighedtInput);
  return;
}
    
   const request = {
  method: "put",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.token,
  },
  body: JSON.stringify(formData),
};

let response = await fetch(user.backEndURL + "/delivery-details", request);
let jsonResponse = await response.json();

if (jsonResponse.success) {
  console.log(jsonResponse.data);
  if (redirectToReview) {
    // ✅ From checkout — update parent state and return to review screen
    // setAddresses(formData);
    
    console.log(billingDetails)
    props.goToScreen("review-subscription", {
      formData: formDataCheckout,
      addresses: {
        ...user.addresses,
        deliveryDetails: formData,
        billingDetails: billingDetails || {}
      }
    });
  } else {
    // ✅ Normal flow — just go back to subscription screen
    props.goToScreen("subscription");
  }
} else {
  helpers.errorPrompt("Oops something went wrong while updating...", null, setErrorPrompt, null);
}
    return;
  };

  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader name={"My Biochar"} content={"Set up your Black Bull Biochar order and start getting biochar delivered straight to your farm! Orders can be placed on an individual or recurring basis for large quantities."}/>
          <div className={"contentGrid"}>
            <Module icon={"location-arrow"} name={"Update Delivery Details"} spanColumn={24} spanRow={1} height={"100%"}>
              <div className={styles.contentWrapper}>
              <div className={styles.detailsRow}>
                  <TextInput name="Contact First Name*" value={formData.firstName} onChange={(value) => handleChange("firstName", value)} highlighted={highlighedtInput === "firstName" ? true : false} labelStyle="top" placeholder="Enter First Name"/>
                  <TextInput name="Contact Last Name*" value={formData.lastName} onChange={(value) => handleChange("lastName", value)} highlighted={highlighedtInput === "lastName" ? true : false} labelStyle="top" placeholder="Enter Last Name"/>
                </div>
                <div className={styles.detailsRow}>
                  <TextInput name="Contact Phone*" value={formData.phone} onChange={(value) => handleChange("phone", value)} highlighted={highlighedtInput === "phone" ? true : false} labelStyle="top" placeholder="Enter Phone"/>
                  <TextInput name="Contact Email*" value={formData.email} onChange={(value) => handleChange("email", value)} highlighted={highlighedtInput === "email" ? true : false} labelStyle="top" placeholder="Enter Email"/>
                </div>
                <div className={styles.detailsRow}>
                  <TextInput name="Business Name" value={formData.businessName} onChange={(value) => handleChange("businessName", value)} highlighted={highlighedtInput === "businessName" ? true : false} labelStyle="top" placeholder="Enter Business Name"/>
                  <TextInput name="Address Line 1*" value={formData.addressLine1} onChange={(value) => handleChange("addressLine1", value)} highlighted={highlighedtInput === "addressLine1" ? true : false} labelStyle="top" placeholder="Enter Address Line 1"/>
                </div>
                <div className={styles.detailsRow}>
                  <TextInput name="City*" value={formData.city} onChange={(value) => handleChange("city", value)} highlighted={highlighedtInput === "city" ? true : false} labelStyle="top" placeholder="Enter City"/>
                  <TextInput name="Address Line 2" value={formData.addressLine2} onChange={(value) => handleChange("addressLine2", value)} highlighted={highlighedtInput === "addressLine2" ? true : false} labelStyle="top" placeholder="Enter Address Line 2"/>
                </div>
                <div className={styles.detailsRow}>
                  <TextInput name="ZIP / Postal Code*" value={formData.zip} onChange={(value) => handleChange("zip", value)} highlighted={highlighedtInput === "zip" ? true : false} labelStyle="top" placeholder="Enter ZIP Code"/>
                  <TextInput name="County" value={formData.county} onChange={(value) => handleChange("county", value)} highlighted={highlighedtInput === "county" ? true : false} labelStyle="top" placeholder="Enter County"/>
                </div>
                <div className={styles.detailsRow}>
                  <TextInput name={"Delivery Details / Instructions"} placeholder={"Enter Text Here"} value={formData.instructions} onChange={(value) => handleChange("instructions", value)} labelStyle={"top"} height={"15rem"}/>
                </div>
                <div className={styles.buttonRow}>
                    <Button onPress={() => redirectToReview ? props.goToScreen("review-subscription", { formDataCheckout: formData, addresses: { ...user.addresses, deliveryDetails: deliveryDetails || {}, billingDetails: locationState.billingDetails } }) : props.goToScreen("subscription")} name={"Cancel"} color="Error"/>
                    <Button onPress={() => handleSubmit()} name={"Update"} color="Grass"/>
                </div>
                <div className={helpers.clx("errorPrompt", styles.errorPromptContainer)}>
                    {errorPrompt}
                </div>
              </div>
            </Module>
          </div>
    </div>
  );
}

export default React.memo(UpdateDeliveryDetailsScreen);
